module.exports = __webpack_public_path__ + "static/media/ebuilt-promo-sale-homes-banner-tablet.e4bcf3eb.webp";